import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

function Title_Section({ title, className }) {
  return (
    <Typography
      variant="h4"
      className={className}
      fontWeight={700}
      component="h1"
    >
      {title}
    </Typography>
  );
}

Title_Section.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default Title_Section;
